<script>
  import ClickOut from '../../../../utils/directives/clickout'
  import Policiais from './policiacivil/configuracoes/Policiais'
  import {GRV_ESPIRITO_SANTO} from '../../../../domain/grv/helpers/tipos-grv'
  import { mapGetters } from 'vuex'
  import ACL from '../../../../domain/acl/tmp-acl'

  export default{
    data () {
      return {
        open: false,
        GRV_ESPIRITO_SANTO
      }
    },
    computed: {
      ...mapGetters(['isLogged', 'currentUser']),
      ACL () {
        return ACL
      }
    },
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      },
      clicked: function (e) {
        console.log('prevented!')
        e.preventDefault()
      }
    },
    components: {
      Policiais
    },
    directives: {ClickOut}
  }
</script>

<template>
  <li :class="{ active: open }">
    <a v-click-out="hide" @click="toggle" class="auto">
      <span class="pull-right text-muted">
      <i class="fa fa-fw fa-angle-right text"></i>
      <i class="fa fa-fw fa-angle-down text-active"></i>
      </span>
      <i class="icon-shield icon text-primary-dk"></i>
      <span>Espirito Santo</span>
    </a>
    <ul class="nav nav-sub dk">
      <li class="nav-sub-header"><a><span class="text-muted teste">Espirito Santo</span></a></li>
      <li>
        <router-link  v-if="!ACL.check('coordES', currentUser.id)" :to="{ name: 'solicitacoes-remocao', query: {tipoGrv: GRV_ESPIRITO_SANTO} }">
          <span>Solicitações de Remoção</span>
        </router-link>
      </li>
      <li>
        <router-link  v-if="!ACL.check('coordES', currentUser.id)" :to="{ name: 'grv', query: {tipoGrv: GRV_ESPIRITO_SANTO} }">
          <span>GRVs</span>
        </router-link>
      </li>

      <Policiais />
    </ul>
  </li>
</template>



// WEBPACK FOOTER //
// EspiritoSanto.vue?37d8fd74